import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const LEARN_PARAM = "learn";

export interface UseLearnParamReturn {
	closePanel: () => void;
	conceptId: string | null;
	openConcept: (conceptId: string) => void;
}

const useLearnParam = (): UseLearnParamReturn => {
	const [searchParams, setSearchParams] = useSearchParams();

	const openConcept = useCallback(
		(conceptId: string) => {
			setSearchParams((current) => {
				const next = new URLSearchParams(current);
				next.set(LEARN_PARAM, conceptId);
				return next;
			});
		},
		[setSearchParams]
	);

	const closePanel = useCallback(() => {
		setSearchParams((current) => {
			const next = new URLSearchParams(current);
			next.delete(LEARN_PARAM);
			return next;
		});
	}, [setSearchParams]);

	return { closePanel, conceptId: searchParams.get(LEARN_PARAM), openConcept };
};

export default useLearnParam;
